'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineDotProps } from '@mui/lab/TimelineDot';

import MuiTimelineDot from '@mui/lab/TimelineDot';

export type { TimelineDotProps };

export const TimelineDot: React.FC<TimelineDotProps> = MuiTimelineDot;

TimelineDot.displayName = 'TimelineDot';
